import { Map } from "immutable";
import { CASE_META_ACTIONS } from "constants/actions";
import { STATE_STATUS } from "constants";

const INITIAL_STATE = new Map({
    status: STATE_STATUS.IDLE,
    caseId: null
});

export default (state=INITIAL_STATE, { type, payload }) => {
    switch(type) {
    case CASE_META_ACTIONS.UPDATE_CASE_META:
        return state.set("status", STATE_STATUS.UPDATING)
            .set("caseId", payload.caseId);
    case CASE_META_ACTIONS.UPDATED_CASE_META:
        return state.set("status", STATE_STATUS.UPDATED);
    case CASE_META_ACTIONS.FAILED_UPDATE_CASE_META:
        return state.set("status", STATE_STATUS.UPDATE_FAILED);
    case CASE_META_ACTIONS.RESET_CASE_META: {
        if(payload.caseId) {
            return INITIAL_STATE.set("caseId", payload.caseId);
        }
        return INITIAL_STATE;
    }
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};